export enum ELanguage {
  GB = "gb",
  DE = "de",
  RS = "rs",
  IT = "it",
  ES = "es",
  FR = "fr",
}
